import React from "react";
import { FieldRenderProps } from "react-final-form";
import { FormFieldProps, Form, Label, Dropdown } from "semantic-ui-react";

interface IProps extends FieldRenderProps<any, any>, FormFieldProps {}

const SelectInputOnSearchChange: React.FC<IProps> = ({
  input,
  width,
  options,
  placeholder,
  search,
  onSearchChange,
  defaultValue,
  meta: { touched, error },
}) => {
  return (
    <Form.Field error={touched && !!error} width={width}>
      <Dropdown
        onSearchChange={(e,data)=>onSearchChange(data.searchQuery)}
        fluid
        search={search}
        selection
        defaultValue={defaultValue}
        value={input.value}
        onChange={(e, data) => input.onChange(data.value)}
        placeholder={placeholder}
        options={options}
      />
      {touched && error && (
        <Label basic color="red">
          {error}
        </Label>
      )}
    </Form.Field>
  );
};

export default SelectInputOnSearchChange;
